/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_JulyInputs */

const es_months_july = /** @type {(inputs: Months_JulyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julio`)
};

const en_months_july = /** @type {(inputs: Months_JulyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`July`)
};

/**
* | output |
* | --- |
* | "July" |
*
* @param {Months_JulyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_july = /** @type {((inputs?: Months_JulyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_JulyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_july(inputs)
	return en_months_july(inputs)
});
export { months_july as "months.july" }